// extracted by mini-css-extract-plugin
module.exports = {"buttonComposite":"style_buttonComposite__1Xa-r","buttonCompositeBody":"style_buttonCompositeBody__2Fk_j","buttonCompositeIcon":"style_buttonCompositeIcon__BR6-D"};